






import { Component, Prop, Vue } from 'vue-property-decorator';
import { ExprVar } from '../../cablin/exprs';

@Component
export default class ExprVarComp extends Vue {
  @Prop() private expr!: ExprVar
}
